<div class="tab-pane" role="tabpanel" id="superficie_ant">
    <fieldset id="agregar_superficie_ant" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Superficies</strong></h3>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group col-md-12">
                                <div><strong>SUP. EDIFICADA BAJO TERRENO:</strong></div>
                            </div>
                            <br />
                            <br />
                            <div class="form-group col-md-12" style="padding-bottom: 30px">

                                <div class="col-md-1">
                                    <label for="destino" class="labelEdi1">UTIL (m2)</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 40px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">

                                        <input matInput id="util1" name="util1" formControlName="util1" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="destino" class="labelEdi2">COMUN (m2)</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="comun1" name="comun1" formControlName="comun1" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="destino" class="labelEdi3">TOTAL (m2)</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px ; ">
                                        <input matInput id="total1" name="total1" formControlName="total1" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="form-group  col-md-12">
                                <div><strong>EDIFICADA SOBRE TERRENO:</strong></div>
                            </div>
                            <br />
                            <br />
                            <div class="form-group col-md-12" style="padding-bottom: 30px">

                                <div class="col-md-1">
                                    <label for="util" class="labelEdi1">UTIL (m2)</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 40px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="util2" name="util2" formControlName="util2" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="destino" class="labelEdi2">COMUN (m2)</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="comun2" name="comun2" formControlName="comun2" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="destino" class="labelEdi3">TOTAL (m2)</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="total2" name="total2" formControlName="total2" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group col-md-12">
                                <div><strong>SUP. EDIFICADA TOTAL:</strong></div>
                            </div>
                            <br />
                            <div class="form-group col-md-12" style="padding-bottom: 30px">
                                <div class="col-md-1">
                                    <label for="util" class="labelEdi1">UTIL (m2)</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 40px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="util3" name="util3" formControlName="util3" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="destino" class="labelEdi2">COMUN (m2)</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="comun3" name="comun3" formControlName="comun3" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1">
                                    <label for="destino" class="labelEdi3">TOTAL (m2)</label>
                                </div>
                                <div class="col-md-2" style="margin-left: 50px ; margin-right: 15px">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="total3" name="total3" formControlName="total3" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group  col-md-12">
                                <div><strong>SUP. TOTAL TERRENO (m2):</strong></div>
                            </div>
                            <br />
                            <br />
                            <div class="form-group col-md-12">
                                <div class="col-md-1">
                                        <label for="destino" class="labelEdi3" style="margin-left: 0px">TOTAL (m2)</label>
                                    </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px; margin-left: 50px;">
                                        <input matInput id="totalt" name="totalt" formControlName="totalt" (change)="add_superficie_anteproyecto()"  />
                                    </mat-form-field>
                                </div>
                                
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>